export const weatherHelper = {
    data: function () {
        return {
            RAIN_DRY_WEATHER: 7,
            RAIN_VERY_LIGHT_RAIN: 8,
            RAIN_DRIZZLE: 9,
            RAIN_RAIN: 10,
            RAIN_SNOWFALL: 11,
            RAIN_WET_SLEET: 12,
            RAIN_SLEET: 13,
            RAIN_HAILS: 14,
            RAIN_ICE_CRYSTALS: 15,
            RAIN_SNOW_GRAINS: 16,
            RAIN_GRAUPEL: 17,
            RAIN_FREEZING_DRIZZLE: 18,
            RAIN_FREEZING_RAIN: 19,
        }
    },
    methods: {
        getRainTypeText(type) {
            switch (type) {
                case this.RAIN_DRY_WEATHER: return this.$t('weather_station.rain_dry_weather')
                case this.RAIN_VERY_LIGHT_RAIN: return this.$t('weather_station.rain_very_light_rain')
                case this.RAIN_DRIZZLE: return this.$t('weather_station.rain_drizzle')
                case this.RAIN_RAIN: return this.$t('weather_station.rain_rain')
                case this.RAIN_SNOWFALL: return this.$t('weather_station.rain_snow_fall')
                case this.RAIN_WET_SLEET: return this.$t('weather_station.rain_wet_sleet')
                case this.RAIN_SLEET: return this.$t('weather_station.rain_sleet')
                case this.RAIN_HAILS: return this.$t('weather_station.rain_hails')
                case this.RAIN_ICE_CRYSTALS: return this.$t('weather_station.rain_ice_crystals')
                case this.RAIN_SNOW_GRAINS: return this.$t('weather_station.rain_snow_grains')
                case this.RAIN_GRAUPEL: return this.$t('weather_station.rain_graupel')
                case this.RAIN_FREEZING_DRIZZLE: return this.$t('weather_station.rain_freezing-drizzle')
                case this.RAIN_FREEZING_RAIN: return this.$t('weather_station.rain_freezing_rain')
            }
            return this.$t('common.unknown')
        },

        getWeatherDataItem(data) {
            const time = this.toLocalTime(data.data_updated_time)
            const station = data.station.name
            const airTemp = data.sensor_values.find(item => item.name === 'ILMA')
            const roadTemp = data.sensor_values.find(item => item.name === 'TIE_1')
            const windMS = data.sensor_values.find(item => item.name === 'KESKITUULI')
            const rainType = data.sensor_values.find(item => item.name === 'SATEEN_OLOMUOTO_PWDXX')
            const rainSum = data.sensor_values.find(item => item.name === 'SADESUMMA')
            return {
                time: time,
                station: station,
                airTemp: airTemp?.value,
                roadTemp: roadTemp?.value,
                windMS: windMS?.value,
                rainType: rainType ? this.getRainTypeText(rainType.value) : '-',
                rainSum: rainSum? rainSum.value : '-'
            }
        },

        getWeatherTable(data) {
            return [
                [this.$t('contracts.external.station'), data.station],
                [this.$t('contracts.external.time'), data.time],
                [this.$t('contracts.external.air_temp'), data.airTemp],
                [this.$t('contracts.external.road_temp'), data.roadTemp],
                [this.$t('contracts.external.avg_wind'), data.windMS],
                [this.$t('contracts.external.rain_type'), data.rainType],
                [this.$t('contracts.external.rain_amount'), data.rainSum]
            ]
        }

    }

}
